import { useTranslation } from 'react-i18next';
import { formatLocaleNumber } from '@/utils';
import { StyledArrow, StyledDynamics } from './DynamicsCellStyles';

interface IDynamicsCellProps {
  value: number | null | undefined;
  /** When true, negative change is good (green). Default for cancellation metrics. */
  invertColors?: boolean;
  suffix?: string;
  decimals?: number;
}

const DynamicsCell = ({ value, invertColors = true, suffix = '%', decimals = 1 }: IDynamicsCellProps) => {
  const { t, i18n } = useTranslation(['dashboard']);

  if (value === null || value === undefined) {
    return <StyledDynamics>{t('cancelled_orders_dynamics_new')}</StyledDynamics>;
  }

  const isUp = value > 0;
  const isDown = value < 0;
  const isGood = invertColors ? isDown : isUp;
  const isBad = invertColors ? isUp : isDown;

  return (
    <StyledDynamics $positive={isGood} $negative={isBad}>
      {isUp || isDown ? <StyledArrow aria-hidden>{isUp ? '↑' : '↓'}</StyledArrow> : null}
      <span>{`${formatLocaleNumber(Math.abs(value), decimals, i18n.language)}${suffix}`}</span>
    </StyledDynamics>
  );
};

export default DynamicsCell;
